import { render, staticRenderFns } from "./Suscriptions.vue?vue&type=template&id=e5dc2966&"
import script from "./Suscriptions.vue?vue&type=script&lang=js&"
export * from "./Suscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports